// TODO: After connection to a real backend, refactor this file
// UI image state cache and sync layer with backend

// Imitates GCP logic/functions. Will be used for mocking stage
import { create } from "zustand";
import {
  clearCachedImageUrl,
  clearAllCachedImageUrls,
} from "@/utils/image-central-manager/tempImageCache";

export const useImageStore = create((set, get) => ({
    images:[],

    // Add one or more images
    addImages: (newImages) => {
      set((state) => {
        const merged = [...state.images, ...newImages];
        try {
          /* eslint-disable no-console */
          console.log("[ImageStore] addImages", {
            incoming: newImages,
            prevCount: state.images.length,
            nextCount: merged.length,
          });
          /* eslint-enable no-console */
        } catch {}
        return { images: merged };
      });
    },
  
    // Remove an image by instanceId.
    removeImage: (instanceId) => {
      set((state) => {
        const toRemove = state.images.find((img) => img.instanceId === instanceId);
        try {
          if (toRemove?.url && typeof URL !== "undefined" && toRemove.url.startsWith("blob:")) {
            URL.revokeObjectURL(toRemove.url);
          }
          if (toRemove?.alt) clearCachedImageUrl(toRemove.alt);
        } catch {}
        return { images: state.images.filter((img) => img.instanceId !== instanceId) };
      });
    },
  
    // Update an image's metadata using instanceId
    updateImageMeta: (instanceId, updatedFields) => {
      set((state) => ({
        images: state.images.map((img) =>
          img.instanceId === instanceId ? { ...img, ...updatedFields } : img
        ),
      }));
    },
  
    // Clear entire image list (dev only or on logout)
    clearImages: () => set((state) => {
      try {
        for (const img of state.images) {
          if (img?.url && typeof URL !== "undefined" && img.url.startsWith("blob:")) {
            URL.revokeObjectURL(img.url);
          }
        }
        clearAllCachedImageUrls();
      } catch {}
      return { images: [] };
    }),
  
    // Read-only getter (if you want to pull without subscribing)
    getImages: () => get().images,
}));
